import React from "react";

const ReportView = ({ report, isViewMode, setIsViewMode }) => {
  return (
    isViewMode && (
      <div
        className={`modal fade ${isViewMode ? "show d-block" : ""}`}
        style={{
          display: "block",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        tabIndex="-1"
        role="dialog"
        aria-hidden={!isViewMode}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) setIsViewMode(false);
        }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div
            className="modal-content"
            style={{
              border: "none",
              borderRadius: "5px",
              boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Modal Header */}
            <div
              className="modal-header"
              style={{
                borderBottom: "none",
                paddingBottom: "10px",
                textAlign: "center",
              }}
            >
              <h4
                className="modal-title w-100"
                style={{
                  fontWeight: "bold",
                  color: "#343a40",
                  textAlign: "center",
                  fontSize: "24px",
                }}
              >
                Report Details
              </h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setIsViewMode(false)}
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="row gy-4 ">
                {/* General Information Card */}
                <div className="col-12">
                  <div
                    className="card border-0 mb-2"
                    style={{
                      borderRadius: "12px",

                      textAlign: "left",
                    }}
                  >
                    <div className="card-body">
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Project Name:</strong>{" "}
                          {report?.project_code.vessel_name || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Invoice No:</strong>{" "}
                          {report?.invoice_no || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Job No:</strong>{" "}
                          {report?.project_code.vessel_code || "N/A"}
                        </h6>
                      </div>
                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Work Order No:</strong>{" "}
                          {report?.order_no || "N/A"}
                        </h6>
                      </div>

                      <div className="mb-3">
                        <h6 className="form-label">
                          <strong>Total Amount:</strong>{" "}
                          {report?.total_without_gst || "N/A"}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ReportView;
